// web-v2/src/lib/v3-flag.js
//
// IS THE V3 API ON, ONCE PER LOAD (V3 Overnight 3, lane C). The one reader of
// GET /api/v3/status (services/v3.service.js getV3Status). Three answers,
// never two: true (200, the flag is on), false (404 v3_api_disabled, the flag
// is off), null (not known: the probe failed some other way or has not
// answered yet). A failed probe is not "off" spelled differently: null is not
// cached, so the next mount asks again, and every caller treats null as "use
// the classic screen", the one that works either way. The reading and the
// caching are lib/v3-flag-probe.js makeFlagReader, which the gate runs against
// a stand-in probe (tests/v3-front-door.test.js 2b). The flag itself lives on
// the server (V3_API_ENABLED, read per request); nothing here decides it.
import { useEffect, useState } from 'react';
import { getV3Status } from '@/services/v3.service.js';
import { makeFlagReader } from '@/lib/v3-flag-probe.js';

export const readV3Flag = makeFlagReader(getV3Status);

export function useV3Enabled() {
  const [v3, setV3] = useState(readV3Flag.peek());
  useEffect(() => {
    let alive = true;
    readV3Flag().then((v) => { if (alive) setV3(v); });
    return () => { alive = false; };
  }, []);
  return v3;
}
